import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { UserService } from 'shared/services';
import { brandShopUrlPrefix, retailersUrlPrefix } from '../../../retailer-platform/brand-shop/utils';

@Injectable()
export class PrivilegesGuard {
    constructor(
        private userService: UserService,
        private router: Router
    ) {}

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.userService.hasAtLeastOnePrivilege(route.data.requiredPrivileges)) {
            return true;
        }

        const noPrivilegesFallbackRoute = route.data.noPrivilegesFallbackRoute;

        if (noPrivilegesFallbackRoute) {
            const fallbackRoute: string = getFallbackRoute({
                noPrivilegesFallbackRoute,
                currentUrl: state.url
            });

            return this.router.parseUrl(fallbackRoute);
        }

        return false;
    }
}

const getFallbackRoute = ({
    noPrivilegesFallbackRoute,
    currentUrl
}: {
    currentUrl: string;
    noPrivilegesFallbackRoute: string | (() => string);
}) => {
    const fallbackRoute: string =
        typeof noPrivilegesFallbackRoute === 'function' ? noPrivilegesFallbackRoute() : noPrivilegesFallbackRoute;

    const isABrandShopRoute = fallbackRoute.search(`${retailersUrlPrefix}/${brandShopUrlPrefix}/:brandId`) !== -1;

    if (isABrandShopRoute) {
        const regex = /([a-f\d]{24}).*/;
        const matches = regex.exec(currentUrl);

        if (matches !== null) {
            const brandId = matches[1];
            return fallbackRoute.replace(':brandId', brandId);
        }
    }

    return fallbackRoute;
};
